export default __webpack_public_path__ + "static/media/dmd-blue-fa.24737f30.svg";